const trailingOrLeadingSlashes = /\/+$|^\/+/g;
const slashes = /\/+/g;

/**
 * Join path parts with /
 *
 * The NodeJS module 'path' is for filesystem paths, not URL paths (aka "relative links"). It exhibits behavior you
 * probably do not want, such as normalizing "../" - this is irrelevant and unwanted when concatenating arbitrary (and
 * especially user-supplied) strings to form URL paths. Use this method instead.
 *
 * It's also not great to use a NodeJS module from the web context (it requires bundler polyfilling of node utilities,
 * which isn't very nice)
 *
 * This method doesn't normalize "." and "..", but it does normalize slashes: if you join "foo/" and "/bar", you can
 * expect "foo/bar" not "foo//bar" (see the test for other examples)
 *
 * Don't forget to encodeURIComponent on any arbitrary strings passed into this function if you're expecting to use
 * the result in a URL path (although you might be using a utility like the URL class to achieve the same thing)
 */
export function joinPathParts(...pathParts: (string | undefined)[]): string {
    return pathParts
        .filter((part): part is string => part !== undefined)
        .map((part) => part.replace(trailingOrLeadingSlashes, "/"))
        .join("/")
        .replace(slashes, "/");
}
